// Back to Top: scroll to top and move focus for keyboard/AT users (WCAG 2.4.3).
// Delegated, guarded against double-binding so a single handler covers all sections.
(function () {
  if (window.__backToTopBound) return;
  window.__backToTopBound = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('#back-to-top-button, .back-to-top-link');
    if (!button) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

    const target = document.getElementById('main-content');
    if (target) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  });
})();
